// autosaveDb — простая обёртка над IndexedDB для автосохранения документа
// Кубикон CAD.
//
// Структура:
//   DB:    'kubikon_cad'
//   Store: 'documents' (key='current')
//   Value: { schemaVersion, title, features, sketches, parameters, savedAt }
//
// Один ключ 'current' — последняя сохранённая версия (отдельный «slot»).
// Полноценный список «Мои проекты» (несколько именованных слотов локально или
// в облаке) — следующий шаг плана.
//
// Использование:
//   await autosave.put(serializeDocument());
//   const data = await autosave.get();   // null если ничего нет
//   await autosave.clear();

const DB_NAME    = 'kubikon_cad';
const DB_VERSION = 1;
const STORE      = 'documents';
const KEY        = 'current';


function openDb() {
    return new Promise((resolve, reject) => {
        const req = indexedDB.open(DB_NAME, DB_VERSION);
        req.onupgradeneeded = () => {
            const db = req.result;
            if (!db.objectStoreNames.contains(STORE)) {
                db.createObjectStore(STORE);
            }
        };
        req.onsuccess = () => resolve(req.result);
        req.onerror   = () => reject(req.error);
    });
}


export async function put(value) {
    const db = await openDb();
    return new Promise((resolve, reject) => {
        const tx = db.transaction(STORE, 'readwrite');
        const store = tx.objectStore(STORE);
        const r = store.put(value, KEY);
        r.onsuccess = () => resolve();
        r.onerror   = () => reject(r.error);
        tx.oncomplete = () => db.close();
    });
}


export async function get() {
    const db = await openDb();
    return new Promise((resolve, reject) => {
        const tx = db.transaction(STORE, 'readonly');
        const store = tx.objectStore(STORE);
        const r = store.get(KEY);
        r.onsuccess = () => resolve(r.result || null);
        r.onerror   = () => reject(r.error);
        tx.oncomplete = () => db.close();
    });
}


export async function clear() {
    const db = await openDb();
    return new Promise((resolve, reject) => {
        const tx = db.transaction(STORE, 'readwrite');
        const store = tx.objectStore(STORE);
        const r = store.delete(KEY);
        r.onsuccess = () => resolve();
        r.onerror   = () => reject(r.error);
        tx.oncomplete = () => db.close();
    });
}


// === Утилита: запоминаем содержательно ли документ ===
// Пустой стартовый документ автосохранять не имеет смысла.
export function isMeaningfulDocument(data) {
    if (!data) return false;
    const f = Array.isArray(data.features) ? data.features.length : 0;
    const s = Array.isArray(data.sketches) ? data.sketches.length : 0;
    return (f + s) > 0;
}
